export default __webpack_public_path__ + "static/media/reset-password-desktop.a63f56d3.png";